module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation12.312cf529.png";